module.exports = __webpack_public_path__ + "static/media/3798.d4562e0f.jpg";